<template>
  <div class="my-6 new-event-bar">
    <md-button
      class="md-success uppercase"
      @click.native="openEventAdditionModal"
      >{{ $t("common.add") }}</md-button
    >
    <event-addition-modal ref="eventAdditionModal" />
  </div>
</template>

<script>
import EventAdditionModal from "./Modals/Addition.vue";

export default {
  name: "event-addition-bar",
  components: { EventAdditionModal },
  methods: {
    openEventAdditionModal() {
      this.$refs.eventAdditionModal.open();
    }
  }
};
</script>

<style lang="scss" scoped>
.new-event-bar {
  padding: 0 20px;
}
</style>
